import mod from "-!./NotFound.js?vue&type=script&lang=js&"; export default mod; export * from "-!./NotFound.js?vue&type=script&lang=js&"